import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import Header from "./components/header/Header";
import Layout from "./components/Layout";
import SidebarBottom from "./components/sidebar/SidebarBottom";
import SidebarTop from "./components/sidebar/SidebarTop";
import Activity from "./pages/activity/Activity";
import Collection from "./pages/collection/Collection";
import Home from "./pages/home/Home";
import ShowCase from "./pages/showcase/ShowCase";
function App() {
	return (
		<>
			<BrowserRouter>
				<Header />
				<Routes>
					<Route
						path="/"
						element={
							<>
								<Layout
									sidebarElement={
										<>
											<SidebarTop />
										</>
									}
								>
									<Home />
								</Layout>
							</>
						}
					/>
					<Route
						path="/activity"
						element={
							<>
								<Layout
									sidebarElement={
										<>
											<SidebarTop />
											<SidebarBottom />
										</>
									}
								>
									<Activity />
								</Layout>
							</>
						}
					/>
					<Route
						path="/collection"
						element={
							<>
								<Layout
									sidebarElement={
										<>
											<SidebarTop />
										</>
									}
								>
									<Collection />
								</Layout>
							</>
						}
					/>
					<Route
						path="/collection/showcase"
						element={
							<>
								<Layout>
									<ShowCase />
								</Layout>
							</>
						}
					/>
					<Route
						path="/collection/owner-showcase"
						element={
							<>
								<Layout>
									<ShowCase ownerShowcase />
								</Layout>
							</>
						}
					/>
				</Routes>
			</BrowserRouter>
		</>
	);
}

export default App;
